import React from 'react';
import { CategoryTag } from '../Tags';
import { CategoryLink } from './CategoryLink';
export var Category = function Category(_ref) {
  var category = _ref.category,
    variant = _ref.variant,
    productType = _ref.productType;
  switch (variant) {
    case 'tag':
      return React.createElement(CategoryTag, {
        entity: category,
        productType: productType
      });
    case 'link':
      return React.createElement(CategoryLink, {
        entity: category,
        productType: productType
      });
    default:
      return React.createElement(CategoryTag, {
        entity: category,
        productType: productType
      });
  }
};